import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sortArrayOfObjects} from "../utilities/methods";
import RealtimeCapture from "../realtimeUpdates";
import { push } from "connected-react-router";
import moment from "moment";

function Dashboard() {
  const products = useSelector((state) => state.product.products);
  const users = useSelector((state) => state.user.users);
  const categories = useSelector((state) => state.category.categories);
  const subCategories = useSelector((state) => state.subCategory.subCategories);
  const notifications = useSelector((state) => state.notification.notifications);
  console.log("Notifications", notifications);
  const dispatch = useDispatch();

  const [_notifications, setNotification] = useState([]),
    [orderby, setOrderBy] = useState("createdAt"),
    [sortby, setSortby] = useState("desc");

  useEffect(() => {
    let filteredNotifications = notifications.sort(
      sortArrayOfObjects(orderby, sortby)
    );
    let filteredNotificationarr = [...filteredNotifications];
    let finalFilteredNotifications = filteredNotificationarr.filter((data) => {
      return data.type === "admin";
    });
    setNotification(finalFilteredNotifications);
  }, [notifications]);

  return (
    <div className="mainContentWrapper">
      <div className="dashContentHeader">
        <h5 className="dashHeading mb-0">Dashboard</h5>
      </div>
      <div className="row dashboardCardRow">
        <div className="col-lg-8">
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle1 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total No listings</h4>
                  <h3 className="card-text mb-4">{products.length}</h3>
                  <a onClick={(e)=>{e.preventDefault(); dispatch(push("/products"));}} href="/" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
            {/*<div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle2 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total views</h4>
                  <h3 className="card-text mb-4">0</h3>
                  <a href="#!" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>*/}
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle3 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Registered Users</h4>
                  <h3 className="card-text mb-4">{users.length}</h3>
                  <a href="/" onClick={(e)=>{
                        e.preventDefault(); 
                        dispatch(push("/registered-users"));
                    }} className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            
            {/*<div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle4 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total Revenue</h4>
                  <h3 className="card-text mb-4">$0</h3>
                  <a href="#!" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>*/}
            <div className="col-md-6  mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle5 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">
                    Total No of Categories
                  </h4>
                  <h3 className="card-text mb-4">{categories.length}</h3>
                  <a href="/" 
                  onClick={(e)=>{
                    e.preventDefault(); 
                    dispatch(push("/category"));
                   }}
                  className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle6 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">
                    Total No of Subcategories
                  </h4>
                  <h3 className="card-text mb-4">{subCategories.length}</h3>
                  <a href="/" 
                    onClick={(e)=>{
                      e.preventDefault(); 
                      dispatch(push("/sub-category"));
                     }}
                    className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            
            
          </div>
        </div>
        <div className="col-lg-4">
          <div className="notificationCol bg-white border-radius-4">
            <h6 className="px-3 pt-3 pb-3 mb-0">Notifications</h6>
            {_notifications && _notifications.length === 0 && <p className="ml-3">No notification found!</p>}
            {_notifications &&
             _notifications.map((notification, index) => {
               return(
                <div key={index} className="media mb-2">
                <span 
                style={{
                   display:"block",
                   height: "40px",
                   width: "40px",
                   lineHeight: "60px",
                   borderRadius: "30px",
                   backgroundColor: "black",
                   color: "white",
                   textAlign:"center",
                   fontSize: "1em"
                }}
                className="d-flex mr-3 justify-content-center align-items-center">
                  {notification.username.charAt(0).toUpperCase()}
                  {/*<svg
                    width={40}
                    height={40}
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx={20}
                      cy={20}
                      r={20}
                      fill="#AD0000"
                      fillOpacity="0.45"
                    />
                    <path
                      d="M15.008 14.976H16.87L19.936 20.282H20.048L23.114 14.976H24.99V25H23.114V20.058L23.226 18.378H23.114L20.566 22.872H19.432L16.87 18.378H16.758L16.87 20.058V25H15.008V14.976Z"
                      fill="white"
                    />
                  </svg>*/}
                </span>
                <div className="media-body">
                  <h5 className="mt-0 noti-heading mb-0">
                    <span>{notification.username},</span> {notification.message}.
                  </h5>
                  <p className="noti-date mb-0">{moment(notification.createdAt).fromNow()}</p>
                </div>
               </div>
               )
             })
            }
          </div>
        </div>
      </div>
      <RealtimeCapture />
    </div>
  );
}

export default Dashboard;
